<template>
<b-container fluid>
  <page-title icon="fas fa-cogs">
    <translate>General Configuration</translate>
  </page-title>
  <b-row>
    <b-col>
      <b-row>
        <b-col lg="8">
          <company-form :company-id="profile.company.id" />
        </b-col>
        <b-col>
          <b-card>
            <set-base-form />
          </b-card>
          <b-card>
            <default-commission-form />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import CompanyForm from '@/components/CompanyForm'
import SetBaseForm from '@/components/SetBaseForm'
import DefaultCommissionForm from '@/components/DefaultCommissionForm'

export default {
  name: 'CompanyProfilePage',
  title() {
    return this.$gettext('Company Profile')
  },
  components: {
    CompanyForm,
    SetBaseForm,
    DefaultCommissionForm
  },
  data() {
    return {
      company: {}
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    getCompany() {
      this.$store.dispatch('fetchProfile')
        .then(() => {
          if (this.profile.company) {
            this.company = this.profile.company
          } else {
            this.$router.push({ name: 'UsersEdit', params: { id: this.profile.id }, query: { setCompany: true } })
          }
        })
    }
  }
}
</script>
